import type { SVGProps } from "react";
export interface UnderpantsIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function UnderpantsIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: UnderpantsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M3.21 8.875a7.13 7.13 0 0 1 6.95 5.545l.97 4.276a1.125 1.125 0 0 1-2.194.5l-.971-4.276a4.88 4.88 0 0 0-4.755-3.796H2.108a1.125 1.125 0 0 1 0-2.25H3.21Zm11.853 10.32a1.125 1.125 0 0 1-2.194-.499l2.194.5Zm6.828-10.32.116.005a1.125 1.125 0 0 1 0 2.239l-.116.005H20.79a4.875 4.875 0 0 0-4.754 3.796l-.973 4.276-1.097-.25-1.097-.25.973-4.276a7.126 7.126 0 0 1 6.948-5.545zm-7.925-2 .116.006a1.125 1.125 0 0 1 0 2.238l-.116.006H10a1.125 1.125 0 0 1 0-2.25z"
      />
      <path
        fill={color}
        d="M20.875 6.5a.375.375 0 0 0-.375-.375h-17a.375.375 0 0 0-.375.375v2.067c0 .838.126 1.672.372 2.473a10.31 10.31 0 0 0 5.89 6.486l.492.205c.229.095.474.143.721.143h2.8c.247 0 .493-.048.722-.143l.49-.205a10.32 10.32 0 0 0 5.892-6.486l.086-.302c.19-.708.285-1.438.285-2.171zm2.25 2.067c0 .93-.121 1.854-.36 2.75l-.11.383a12.57 12.57 0 0 1-7.177 7.903l-.492.205a4.1 4.1 0 0 1-1.587.317H10.6c-.408 0-.813-.06-1.203-.18l-.383-.137-.493-.205A12.56 12.56 0 0 1 1.347 11.7a10.7 10.7 0 0 1-.472-3.133V6.5A2.625 2.625 0 0 1 3.5 3.875h17A2.625 2.625 0 0 1 23.125 6.5z"
      />
    </svg>
  );
}
